export default __webpack_public_path__ + "static/FKScreamer-Black-c9b378c5539f445c4a1eb40cff876be5.woff";